import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { SitesWidgetComponentController } from "./SitesWidgetComponentController";

export class SitesWidgetComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {};
        this.controller = SitesWidgetComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Widgets/Widget.html";
    }
}
